import React, { useState } from 'react';
import uploadImg from '../../assets/images/accordion-plus.svg';

const InputFile = ({ onImageUpload }) => {
    const [nftImageSrc, setNftImageSrc] = useState(null);

    const imageChangeHandler = (event) => {
        onImageUpload(event.target.files[0]);
        setNftImageSrc(URL.createObjectURL(event.target.files[0]));
    };
    const imageRemoveHandler = () => {
        onImageUpload(null);
        setNftImageSrc(null);
    };
    return (
        <div className="file-img-wrapper signup-file-upload">
            <div className="img-upload">
                <img src={nftImageSrc ? nftImageSrc : uploadImg} alt="name-img" />
            </div>
            <label className="img-file" htmlFor="bannerImage"></label>
            {!nftImageSrc && (
                <input onChange={imageChangeHandler} type="file" id="bannerImage" className="img-file" accept="image/png, image/gif, image/jpeg" />
            )}
            {nftImageSrc && <button onClick={imageRemoveHandler} type="button" className="cross-btn"></button>}
        </div>
    );
};

export default InputFile;
